"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _core = require("@material-ui/core");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _index = _interopRequireDefault(require("./index.style"));
var _theme = _interopRequireDefault(require("../../theme"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tooltip = _ref => {
  let {
    element,
    content,
    toolTipExtraClasses,
    tooltipProps,
    elementClassName,
    onClickTooltipHandler = () => {}
  } = _ref;
  const classes = (0, _index.default)();
  const [show, setShow] = (0, _react.useState)(false);
  const isDesktop = (0, _useMediaQuery.default)(_theme.default.breakpoints.down('lg'));
  const HtmlTooltip = (0, _styles.withStyles)(() => ({
    tooltip: {
      backgroundColor: _theme.default.palette.white,
      color: 'rgba(0, 0, 0, 0.87)',
      border: '0',
      boxShadow: "0 0 10px 2px ".concat(_theme.default.palette.shadow, " "),
      margin: 0,
      padding: 0,
      marginTop: '10px',
      '& .MuiTooltip-arrow': {
        width: '2em',
        height: '1em',
        color: _theme.default.palette.white
      },
      '& .MuiTooltip-arrow::before': {
        borderStyle: 'solid',
        flip: false,
        borderColor: 'transparent transparent currentcolor transparent',
        borderWidth: '0 1em 1em 1em',
        transform: 'none',
        width: '0',
        height: '0'
      },
      '.MuiTooltip-popperArrow[x-placement*="top"] &': {
        '& .MuiTooltip-arrow': {
          transform: 'rotate(180deg)'
        }
      }
    },
    arrow: {
      fontSize: 10,
      color: _theme.default.palette.white,
      '&::before': {
        backgroundColor: 'transparent'
      }
    }
  }))(_Tooltip.default);
  const handleClick = () => {
    if (isDesktop) {
      setShow(!show);
      onClickTooltipHandler();
    }
  };
  const handleHover = action => {
    if (!isDesktop) {
      setShow(action);
    }
  };
  const clickListener = () => {
    setShow(false);
  };
  (0, _react.useEffect)(() => {
    document.addEventListener('mousedown', clickListener);
    return () => {
      document.removeEventListener('mousedown', clickListener);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.tooltip
  }, /*#__PURE__*/_react.default.createElement(HtmlTooltip, (0, _extends2.default)({
    classes: {
      arrow: classes.arrow,
      ...toolTipExtraClasses
    },
    arrow: true,
    interactive: true,
    open: show,
    disableHoverListener: true,
    onMouseEnter: () => handleHover(true),
    onMouseLeave: () => handleHover(false),
    title:
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/_react.default.createElement("div", null, content), isDesktop ? /*#__PURE__*/_react.default.createElement(_core.Button, {
      "data-testid": "close-btn",
      disableTouchRipple: true,
      className: classes.closeBtn,
      onClick: () => setShow(false)
    }, /*#__PURE__*/_react.default.createElement(_Close.default, null)) : '')
  }, tooltipProps), /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "element",
    "aria-pressed": "false",
    tabIndex: 0,
    className: elementClassName,
    role: "button",
    onKeyDown: handleClick,
    onClick: handleClick
  }, element)));
};
var _default = exports.default = Tooltip;